<template>
    <div class="catalog-search-view" :class="{ 'embedded-search': embedded }">
        <div class="search-overlay">
            <div class="search-overlay-header">
                <h1 class="search-form-title">{{ $t('search.language_0') }}</h1>
                <p class="search-form-subtitle">{{ $t('search.language_1') }}</p>
                <form @submit.prevent="handleSearch" class="search-form" >
                    <div class="search-box">
                        <i class="el-icon-search"></i>
                        <input ref="searchInput" type="text" class="search-input" :placeholder="$t('search.language_2')" :aria-label="$t('search.language_2')" v-model="searchValue" name="s">
                        <button type="button" v-if="searchValue" @click.stop="clearSearch" :aria-label="$t('search.language_3')" class="search-clear-btn">×</button>
                    </div>
                    <button class="btn" type="submit">
                        {{ $t('search.language_4') }}
                    </button>
                </form>
            </div>
            <div class="turbo-frame-content">
                <div class="turbo-row">
                    <div class="turbo-col turnbo-intronduction">
                        <h3>KAMS Code Introduction</h3>
                        <img src="@/assets/image/search/introduction.png" alt="">
                    </div>
                    <div class="turbo-col turnbo-example">
                        <h3>Example</h3>
                        <p>K-CL36-203F-R2D</p>
                        <p>
                            -K -> KAMS,
                            <br/>
                             -CL -> Ceiling spot light 
                            <br/>
                            -36 -> Series code,
                            <br/>
                            -20 -> 2
                            <br/>
                            -3 -> 3W 
                            <br/>
                            -F -> Fixation,
                            <br/>
                            -R -> Round  
                            <br/>
                            -2 -> shard  
                            <br/>
                            -D -> dark
                            <br/>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <button type="button" class="close-btn" aria-label="Close search" @click.stop="closeSearch">
            <i class="el-icon-close"></i>
        </button>
    </div>    
</template>
<script>
export default {
    props: { embedded: { type: Boolean, default: false } },
    data(){
        return {
            searchValue: ''
        }
    }, 
    methods:{
        focusInput() { this.$refs.searchInput.focus() },
        closeSearch(){
            this.$emit('closeSearch')
        },
        handleSearch() {
            if (this.searchValue.trim().length < 2) {
                return
            }
            // 获取当前语言前缀
            const currentLang = this.$i18n?.locale || 'en';
            const targetRoute = `/${currentLang}/search?s=${encodeURIComponent(this.searchValue.trim())}`;
            
            // 检查当前是否已经在搜索页面
            if (this.$route.path.includes('/search')) {
                // 如果已经在搜索页面，更新URL参数而不重新加载页面
                this.$router.replace(targetRoute);
            } else {
                // 如果不在搜索页面，进行正常跳转
                this.$router.push(targetRoute);
            }
            
            this.closeSearch();
        },
        clearSearch() {
            this.searchValue = '';
            this.focusInput();
        }
    }
}
</script>
<style lang="less" scoped>
.catalog-search-view{
    --header-height: 5.625rem;
    position: fixed;
    top: calc(var(--header-height) + 0rem);
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000;
    background-color: white;
    .search-overlay{
        width: 120rem;
        margin: 0 auto;
        color: black;
        padding: 12rem 0;
        .search-overlay-header{
           text-align: center;
           .search-form-title{
                font-weight: 700;
                font-size: 48px;
                line-height: 1.25;
           }
           .search-form-subtitle{
                font-weight: 400;
                font-size: 24px;
                line-height: 1.5;
                color: #666666;
           }
           .search-form{
                width: 80%;
                display: flex;
                flex-wrap: wrap;
                margin: 0 auto;
                justify-content: center;
                padding: 50px 0;
                    .search-box{
                        width: 200px;
                        flex-grow: 1;
                        display: flex;
                        flex-wrap: wrap;
                        align-items: center;
                        border-width: 1px;
                        border-radius: .375rem;
                        border: solid 1px #ccc;
                        height: 4.375rem;
                        overflow: hidden;
                        .el-icon-search{
                            width: 1.5rem;
                            height: 1.5rem;
                            padding: 0 1.25rem;
                        }
                        .search-input{
                            flex: 1;
                            border: none;
                            height: 100%;
                            font-weight: 700;
                            line-height: var(--header-height);
                            font-size: 16px;
                            &:focus{
                                outline: none;
                            }
                        }
                    }
                    .btn{
                        font-size: 1.125rem;
                        width: 12.5rem;
                        --brand-color:rgba(0, 0, 0, 1);
                        --bg-color: var(--brand-color);
                        height: auto;
                        margin-left: 1rem;
                        color: #fff;
                        background-color: var(--bg-color);
                        border-color: var(--brand-color);
                        border-radius: .375em;
                        align-items: center;
                        justify-content: center;
                        position: relative;
                        overflow: hidden;
                        font-weight: bold;
                    }
           }
        }
    }
    .turbo-frame-content{
        width: 80%;
        margin: 0 auto;
        .turbo-row{
            width: 100%;
            display: flex;
            .turnbo-intronduction{
                width: 70%;
                text-align: left;
                img{
                    width: 80%;
                }
            }
            .turnbo-example{
                flex: 1;
                text-align: left;
                p{
                    margin-top: 40px;
                }
            }
        }
    }
    .close-btn{
        border: none;
        background-color: rgba(255, 255, 255, 0);
        position: absolute;
        width: 4rem;
        height: 4rem;
        top: calc(var(--header-height) - 3rem);
        right: 3rem;
        stroke-width: 1px;
        border-radius: 4px;
        transition-property: background-color;
        transition-duration: var(--default-duration);
        transition-timing-function: var(--default-timing-function);
        color: var(--brand-color);
        i{
            font-size: 48px;
            color: black;
        }
    }
}
    /* 移动端兼容性优化 */
    @media (max-width: 768px) {
        .catalog-search-view {
            --header-height: 4rem;
            overflow-x: hidden;
            background-color: #f8f9fa; /* 更改背景色为浅灰色，更现代 */
            
            .search-overlay {
                width: 90%;
                padding: 4rem 1rem 3rem;
                box-sizing: border-box;
                max-width: 600px; /* 限制最大宽度，确保内容居中 */
                margin: 0 auto;
                
                .search-overlay-header {
                    padding: 0 0.5rem;
                    text-align: center;
                    
                    .search-form-title {
                        font-size: 32px; /* 增大标题字体 */
                        margin-bottom: 12px;
                        line-height: 1.3;
                        color: #1a1a1a;
                        font-weight: 700;
                    }
                    
                    .search-form-subtitle {
                        font-size: 16px;
                        line-height: 1.5;
                        margin-bottom: 30px;
                        color: #666;
                    }
                    
                    .search-form {
                        width: 100%;
                        padding: 0;
                        
                        .search-box {
                            height: 3.75rem;
                            width: 100%;
                            border-radius: 2rem;
                            border: 1px solid #e0e0e0;
                            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
                            transition: all 0.3s ease;
                            background-color: #fff;
                            height: 40px;
                            &:focus-within {
                                border-color: #409EFF;
                                box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
                                transform: translateY(-1px);
                            }
                            
                            .el-icon-search {
                                font-size: 18px;
                                color: #909399;
                                transition: color 0.3s ease;
                                padding:  4px 14px 14px;
                            }
                            
                            .search-input {
                                font-size: 16px;
                                padding: 0 0.5rem;
                                line-height: 1.5;
                                color: #303133;
                            }
                            
                            .search-clear-btn {
                                padding: 0 1.25rem;
                                font-size: 18px;
                                color: #909399;
                                cursor: pointer;
                                
                                &:hover {
                                    color: #606266;
                                }
                                
                                // 添加清除按钮的样式
                                &::before {
                                    content: none;
                                    font-size: 24px;
                                    line-height: 1;
                                }
                            }
                        }
                        
                        .btn {
                            width: 100%;
                            margin-left: 0;
                            margin-top: 1.5rem;
                            height: 3.75rem;
                            font-size: 1.125rem;
                            border-radius: 2rem;
                            background-color: #000;
                            color: #fff;
                            border: none;
                            font-weight: 600;
                            cursor: pointer;
                            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
                            transition: all 0.3s ease;
                            
                            &:hover {
                                background-color: #333;
                                box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
                                transform: translateY(-2px);
                            }
                            
                            &:active {
                                transform: translateY(0);
                            }
                        }
                    }
                }
            }
            
            .turbo-frame-content {
                width: 100%;
                padding: 0 1rem;
                box-sizing: border-box;
                margin-top: 3rem;
                max-width: 600px; /* 限制最大宽度 */
                margin-left: auto;
                margin-right: auto;
                
                .turbo-row {
                    flex-direction: column;
                    gap: 2.5rem;
                    
                    .turbo-col {
                        width: 100% !important;
                        margin-bottom: 0;
                        background-color: #fff;
                        padding: 1.5rem;
                        border-radius: 12px;
                        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
                        
                        h3 {
                            font-size: 22px;
                            margin-bottom: 1.5rem;
                            font-weight: 600;
                            color: #1a1a1a;
                            border-bottom: 2px solid #f0f0f0;
                            padding-bottom: 0.75rem;
                        }
                        
                        &.turnbo-intronduction {
                            img {
                                width: 100%;
                                height: auto;
                                display: block;
                                border-radius: 8px;
                                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                            }
                        }
                        
                        &.turnbo-example {
                            p {
                                margin-top: 0;
                                margin-bottom: 1rem;
                                font-size: 15px;
                                line-height: 1.7;
                                color: #333;
                            }
                            
                            p:first-of-type {
                                font-weight: 700;
                                margin-bottom: 1.5rem;
                                color: #000;
                                font-size: 16px;
                            }
                        }
                    }
                }
            }
            
            .close-btn {
                width: 3rem; /* 增加触摸目标大小 */
                height: 3rem;
                top: 1rem;
                right: 1rem;
                z-index: 1001;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                background-color: rgba(0, 0, 0, 0.05);
                transition: all 0.3s ease;
                
                &:hover {
                    background-color: rgba(0, 0, 0, 0.1);
                    transform: scale(1.1);
                }
                
                &:active {
                    transform: scale(0.95);
                }
                
                i {
                    font-size: 28px;
                    color: #333;
                    pointer-events: none; /* 确保点击事件只触发在按钮上 */
                }
            }
            
            /* 优化整体触摸体验 */
            * {
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
            }
            
            /* 确保所有按钮都有足够的触摸目标大小 */
            button, .btn, .search-clear-btn {
                min-width: 48px;
                min-height: 48px;
            }
        }
    }
    
    /* 平板设备优化 */
    @media (min-width: 769px) and (max-width: 1024px) {
        .catalog-search-view {
            .search-overlay {
                width: 90%;
                padding: 6rem 2rem 4rem;
            }
            
            .search-overlay-header {
                .search-form-title {
                    font-size: 36px;
                }
                
                .search-form-subtitle {
                    font-size: 20px;
                }
                
                .search-form {
                    width: 90%;
                    
                    .search-box {
                        height: 4rem;
                    }
                    
                    .btn {
                        width: 10rem;
                        height: 4rem;
                    }
                }
            }
            
            .turbo-frame-content {
                width: 90%;
                
                .turbo-row {
                    .turnbo-intronduction {
                        width: 60%;
                    }
                    
                    .turbo-col {
                        h3 {
                            font-size: 22px;
                        }
                    }
                }
            }
        }
    }
    
    /* 小屏幕手机优化 */
    @media (max-width: 480px) {
        .catalog-search-view {
            z-index: 10002 !important;
            .search-overlay {
                padding: 3rem 0.75rem 2rem;
                
                .search-overlay-header {
                    .search-form-title {
                        font-size: 24px;
                    }
                    
                    .search-form-subtitle {
                        font-size: 14px;
                    }
                    
                    .search-form {
                        .search-box {
                            height: 40px;
                            .el-icon-search{
                                font-size: 12px;
                                padding: 6px 12px 12px;
                            }
                            .search-input {
                                font-size: 15px;
                            }
                        }
                        
                        .btn {
                            height: 20px;
                            font-size: 12px;
                        }
                    }
                }
            }
            
            .turbo-frame-content {
                padding: 0 0.75rem;
                
                .turbo-col {
                    h3 {
                        font-size: 18px;
                    }
                    
                    &.turnbo-example {
                        p {
                            font-size: 14px;
                        }
                    }
                }
            }
            
            .close-btn {
                top: 0.75rem;
                right: 0.75rem;
                
                i {
                    font-size: 24px;
                }
            }
        }
    }
// Keep the search surface independent of navigation layout and inherited colors.
.catalog-search-view {
    height: calc(100vh - var(--header-height));
    overflow-y: auto;
    overflow-x: hidden;
    color: #222;
    background: #fff;
    box-sizing: border-box;

    &.embedded-search {
        position: relative;
        inset: auto;
        width: 100%;
        height: auto;
        min-height: 100vh;
        z-index: auto;
    }
    .search-overlay {
        width: calc(100% - 48px);
        max-width: 1120px;
        padding: 80px 0 48px;
        box-sizing: border-box;
        .search-overlay-header {
            .search-form-title { margin: 0 0 16px; color: #222; font-size: clamp(28px, 3vw, 44px); }
            .search-form-subtitle { margin: 0; font-size: clamp(16px, 1.5vw, 20px); overflow-wrap: anywhere; }
            .search-form {
                width: 100%;
                padding: 32px 0 48px;
                gap: 16px;
                .search-box {
                    flex: 1 1 240px;
                    min-width: 0;
                    height: 56px;
                    flex-wrap: nowrap;
                    background: #fff;
                    border-radius: 6px;
                    box-sizing: border-box;
                    .el-icon-search { width: auto; height: auto; padding: 0 16px; font-size: 20px; color: #666; }
                    .search-input { min-width: 0; padding: 0; font-size: 16px; line-height: normal; background: transparent; color: #222; }
                    .search-clear-btn { flex: 0 0 44px; border: 0; padding: 0; height: 44px; background: transparent; color: #666; font-size: 24px; cursor: pointer; }
                    &:focus-within { border-color: #222; }
                }
                .btn { width: 140px; height: 56px; margin: 0; font-size: 16px; border-radius: 6px; cursor: pointer; }
            }
        }
    }
    .turbo-frame-content {
        width: 100%;
        max-width: none;
        padding: 0;
        .turbo-row {
            gap: 32px;
            .turbo-col { box-sizing: border-box; }
            h3 { font-size: 22px; color: #222; }
            .turnbo-intronduction img { display: block; width: 100%; height: auto; }
            .turnbo-example p { margin-top: 20px; font-size: 16px; line-height: 1.7; color: #333; }
        }
    }
    .close-btn { top: 16px; right: 24px; width: 44px; height: 44px; display: flex; align-items: center; justify-content: center; color: #222; cursor: pointer; }
    .close-btn i { font-size: 28px; }
    button:focus-visible { outline: 2px solid #222; outline-offset: 3px; }
}
@media (max-width: 768px) {
    .catalog-search-view .search-overlay .search-overlay-header .search-form .btn { width: 100%; }
    .catalog-search-view .close-btn { right: 12px; }
}
</style>
